import { DdppBannerVariant } from "src/components/DdppLegalBanner";

// Agencies impacted by the DDPP injunction (ML-25365).
// Each agency has its own legal notice text (see DdppLegalBanner component).
// Keys are the Mongo `_id` of the Agency documents in the legacy plato DB.
export const DDPP_BANNER_VARIANT_BY_AGENCY_ID: Readonly<Record<string, DdppBannerVariant>> = {
  "60df7a6d29341011d621df0b": "GRESIVAUDAN",
  "5e5dafe02a1a656ca2020c6a": "ALPES_DAUPHINE",
  "629710156446f7bce6417ee1": "AGDA",
};
